export function createMarkup(html) {
  return {__html: html}
}